import { injectable } from 'inversify';

@injectable()
abstract class Tracker {
  abstract track(payload?: Record<string, any> & {
    eventName?: string,
  }): Promise<void> | void;
}

export default Tracker;
